module.exports = __webpack_public_path__ + "assets/consultation.8fd4bd02.svg";